import { render, staticRenderFns } from "./questionListEditor.vue?vue&type=template&id=64f5b359&scoped=true"
import script from "./questionListEditor.vue?vue&type=script&lang=js"
export * from "./questionListEditor.vue?vue&type=script&lang=js"
import style0 from "./questionListEditor.vue?vue&type=style&index=0&id=64f5b359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5b359",
  null
  
)

export default component.exports